import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { FeatureHeaderProperties } from './index';
import { parseJson } from '@/utils/parseJson';
interface SubTitleProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const SubTitle: React.FC<SubTitleProps> = ({ className, properties }) => {
  const { sub_title, sub_title_style } = properties;
  const subTitleStyle = parseJson(sub_title_style) ?? {};

  if (!sub_title) return <></>;
  return (
    <div
      data-role="sub-title"
      data-testid="wid-featured-header-sub-title"
      className={twMerge('enki-body-xs !font-semibold text-primary-2 break-words uppercase', className)}
      style={{
        color: subTitleStyle.color
      }}>
      {sub_title}
    </div>
  );
};

export default SubTitle;
